import { bindActionCreators } from 'redux'
import { Reset } from '@piconetworks/login'
import withInjection from '@piconetworks/with-injection'

import Internal from 'common/modules/internal'
import Account from 'common/modules/account'
import Wizard from 'common/modules/wizard'

import WizardRedux from 'common/pkgs/WizardRedux'

const mapStateToProps = (state, props) => ({
    ...props,
    guestLoader: state?.loader?.guest,
    userLoader: state?.loader?.user,
    thisWizard: Wizard.selectors.thisWizard({ state, router: props.router }),
    passwordResetSent: state.account.passwordResetSent,
    requestPasswordError: state.account.requestPasswordError,
    WizardRedux,
    redirectUrl: state.zoid?.xprops?.content?.url.concat('?pn=reset_password'),
    loginEmail: Account.selectors.loginEmail(state),
})

const mapDispatchToProps = (dispatch) => ({
    ...bindActionCreators({
        requestPasswordReset: Account.creators.requestPasswordReset,
    }, dispatch),
    newsletterSubscribe: (payload) => Internal.helpers.invalidateLoader({
        payload,
        action: Account.creators.newsletterSubscribe,
        dispatch,
    }),
})

const InjectedReset = withInjection(Reset, {
    mapStateToProps,
    mapDispatchToProps,
})

export default InjectedReset
